import { RouteDataService } from './../../services/route-data.service';
import { MenuService } from './../../services/menu.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-show-how-it-works',
  templateUrl: './show-how-it-works.component.html',
  styleUrls: ['./show-how-it-works.component.scss']
})
export class ShowHowItWorksComponent implements OnInit {
  @Input() currentPageId: number;
  @Output() canAccessCalendar = new EventEmitter<boolean>();

  howItWorksData: any;
  routerList: any[];
  appointments: any[];
  loginUserData: any;
  loader: any;
  constructor(
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _menuService: MenuService,
    private _routeDataService: RouteDataService,
    public _router: Router,
    private _routes: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    const localData = localStorage.getItem('loginUserData');
    this.loginUserData = JSON.parse(localData);

    this._routeDataService.studentRouteData.subscribe((routes: any[]) => {
      this.routerList = routes;
      const currentRoute = this._routes.snapshot.url[0].path;

      for (let i = 0; i < routes.length; i++) {
        if (routes[i].path === currentRoute) {
          this._menuService.setCurrentRouteData(routes[i]);
          this.currentPageId = routes[i].id;
          this.getHowItWorksData();
        }
      }
    });
    this.currentPageId = this._menuService.getCurrentPageId();
    this.getHowItWorksData();

    if (this.loginUserData && this.loginUserData.userId && this._router.url !== '/coach/coachStudentDetail') {
      this.getCalendarAppointments(this.loginUserData.userId);
    }
  }

  getHowItWorksData() {
    const inputJson = {
      pageclassid: this.currentPageId
    };
    this._commonRequestResponseService.postWithHeader('shared/contentdetails/howItWorks', inputJson)
      .subscribe(
        (howItworksJson: any) => {
          this.howItWorksData = howItworksJson;
        },
        () => {
          this.notificationService.show('info', 'Error while getting how it works data');
        });
  }

  getCalendarAppointments(loggedInUserId) {
    const jsonInput = {
      userId: loggedInUserId
    };

    this._commonRequestResponseService.postWithHeader('shared/getCalendarAppointments', jsonInput)
      .subscribe(
        (data: any) => {
          this.appointments = data && data.appointments ? data.appointments : [];
          this.canAccessCalendar.emit(data.canAccessCalendar);
        },
        () => {
          this.notificationService.show('error', 'Error while fetching appointments data');
        });
  };

  deleteCancelStatus(item) {
    this.loader = true;
    this._commonRequestResponseService.delete('Shared/DeleteLBAppointment?id=' + item.id + '&appointmentId=' + item.appointmentId + '&contactId=' + item.leadBadgeContactId, {})
      .subscribe(
        (data: any) => {
          this.notificationService.show('success', 'Appointment cancelled successfully');
          this.getCalendarAppointments(this.loginUserData.userId);
          this.canAccessCalendar.emit(data.canAccessCalendar);
          this.loader = false;
        },
        () => {
          this.notificationService.show('error', 'Error while cancelling appointment');
          this.loader = false;
        });
  };
}
